// const apiURL = process.env.REACT_APP_API_URL;
// const wsURL = process.env.REACT_APP_WS_URL;
// export const BASE_API = apiURL;
// export const WS_BASE_API = wsURL;
// export const DOMAIN = process.env.REACT_APP_URL;

// export const DOMAIN = 'http://127.0.0.1:8005';
// export const BASE_API = 'http://127.0.0.1:8005/api/';
// export const WS_BASE_API = 'WS://127.0.0.1:8005/ws/';
export const DOMAIN = 'https://pricereport.tabangohar.com';
export const BASE_API = 'https://pricereport.tabangohar.com/api/';
export const WS_BASE_API = 'WSS://pricereport.tabangohar.com/ws/';
export const TGN_API_URL = `${BASE_API}tgn-gold-prices/`;
export const QUANTITY_DEFINITION_API  = `${BASE_API}quantity-definitions/`;
export const QUANTITY_DEFINITION_UNIT_API  = `${BASE_API}quantity-definition-units/`;
export const QUANTITY_DEFINITION_CATEGORY_API  = `${BASE_API}quantity-definition-categories/`;
export const EXTERNAL_QUANTITY_DEFINITION_CATEGORY_API  = `${BASE_API}external-quantity-definition-categories/`;
export const EXTERNAL_QUANTITY_DEFINITION_API  = `${BASE_API}external-quantity-definitions/`;
export const QUANTITY_DEFINITION_MAPPING_API = `${BASE_API}quantity-definition-mappings/`
export const TRANSACTION_TYPE_API_URL = `${BASE_API}transaction-types/`;
export const GOLD_TRANSFER_TRANSACTION_TYPE_API_URL = `${BASE_API}gold-transfer-transaction-types/`;
export const GOLD_TYPE_API = `${BASE_API}gold-types/`;
export const GOLD_PRICE_API = `${BASE_API}gold-prices/`;
export const GOLD_PRICE_ACTIVENESS_HISTORY_API = `${BASE_API}gold-price-activeness-histories/`;
export const GOLD_PRICE_TYPE_API = `${BASE_API}gold-price-types/`;
export const GOLD_PRICE_IS_ACTIVE_API = `${BASE_API}gold-price-is-active/`;
export const GOLD_PRICE_STEP_API = `${BASE_API}gold-price-steps/`;
export const ACCOUNT_BALANCE_API = `${BASE_API}account-balances/`;
export const PURCHASING_POWER_API_URL = `${BASE_API}purchasing-power/`;
export const ASSET_API_URL = `${BASE_API}assets/`;
export const REAL_ASSET_API = `${BASE_API}real-assets/`;
export const CREDIT_API_URL = `${BASE_API}credits/`;
export const WALLET_API_URL = `${BASE_API}wallets/`;
export const TRANSACTION_EXPIRATIONS = `${BASE_API}transaction-expirations/`;
export const TRANSACTION_API_URL = `${BASE_API}transactions/`;
export const SEND_TRANSACTION_TO_SOURCE_API = `${BASE_API}send-transaction-to-source/`;
export const TRANSACTION_FIELD_VISIBILITY_API_URL = `${BASE_API}transaction-field-visibilities/`; 
export const ONLINE_ORDER_API_URL = `${BASE_API}online-orders/`;
export const IN_CALL_ORDER_API_URL = `${BASE_API}in-call-orders/`;
export const IN_PERSON_ORDER_API_URL = `${BASE_API}in-person-orders/`;
export const RECEIVE_OR_DELIVER_ORDER_API_URL = `${BASE_API}receive-or-deliver-orders/`;
export const TRANSACTION_ORDER_TYPE_API_URL = `${BASE_API}transaction-order-types/`;
export const NOTIFICATION_API_URL = `${BASE_API}notifications/`;
export const RECEIPT_API_URL = `${BASE_API}receipts/`;
export const CAPTCHA_API = `${BASE_API}captchas/`;
export const PORIFILES_API = `${BASE_API}profiles/`;
export const REORDER_DATA_API = `${BASE_API}reorder/`;
export const TREE_DATA_API = `${BASE_API}tree-data`;
export const ADMIN_MESSAGE_API = `${BASE_API}manager-messages/`;

export const OFFLINE_MODE_API = `${BASE_API}offline-modes/`;
export const GOLD_CREDIT_API = `${BASE_API}gold-credits/`;
export const GOLD_DATA_SOURCE_API = `${BASE_API}gold-data-sources/`;
export const GOLD_DATA_SOURCE_TOKEN_API = `${BASE_API}gold-data-source-tokens/`;
export const PARTNER_API = `${BASE_API}partners/`;
export const PARTNER_TOKEN_API = `${BASE_API}partner-tokens/`;
export const PARTNER_PRICE_MARKUP_API = `${BASE_API}partner-price-markups/`;
export const PRICE_MARKUP_API = `${BASE_API}price-markups/`;
export const PRICE_MARKUP_TYPE_API = `${BASE_API}price-markup-types/`;
export const PRICE_MARKUP_CHANGE_TYPE_API = `${BASE_API}price-markup-change-types/`;
export const GOLD_PRICE_ROUNDING_API = `${BASE_API}gold-price-roundings/`;
export const WS_ADMIN_MESSAGE_API = `${WS_BASE_API}manager-messages/`;
export const WS_OFFLINE_MODE_API = `${WS_BASE_API}offline-mode/`;
export const USER_API = `${BASE_API}users/`;
export const USER_TOKEN_API = `${BASE_API}user-tokens/`;
export const USER_TOKEN_EXPIRE_TYPE_API = `${BASE_API}user-token-expire-types/`;
export const AUTO_SEND_TRANSACTION_API = `${BASE_API}auto-send-transactions/`;
export const GEO_AREA_API = `${BASE_API}geo-areas/`;
export const SITE_SETTINGS_API = `${BASE_API}site-settings/`;

export const HAMKARTALA_GOLD_PRICE_ACTIVENESSES = 'https://hamkartala.ir/api/gold-price-activenesses/';
export const FARVARDINGOLD_GOLD_PRICE_ACTIVENESSES = 'https://farvardingold.ir/api/gold-price-activenesses/';
export const T1_GOLD_PRICE_ACTIVENESSES = 'https://t1.tabangohar.com/api/gold-price-activenesses/';
